export const AUTOCOMPLETE_RESET_DATA = "AUTOCOMPLETE_RESET_DATA";
export const AUTOCOMPLETE_SAVE_DATA = "AUTOCOMPLETE_SAVE_DATA";
